import * as Yup from "yup";

// Regex for your format: 2025-07-08T00:00:00.000889
const customDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6}$/;

// Unified Add/Update schema: use `mode: 'add' | 'update'` in data
export const SponsorValidationSchema = Yup.object().shape({
  mode: Yup.string()
    .oneOf(["add", "update"]) // must be provided in formData
    .required(),

  Name: Yup.string()
    .required("0:Sponsor name is required")
    .max(30, "1:Sponsor name must be at most 30 characters"),

  LogoImage: Yup.mixed().when("mode", (mode, schema) => {
    if (mode === "add") {
      return schema
        .required("2:Sponsor logo is required")
        .test(
          "fileType",
          "4:Only JPG/PNG files are allowed",
          (value) => !value || value.type === "image/jpeg" || value.type === "image/png"
        )
        .test(
          "fileSize",
          "10:Image size must be less than 400KB",
          (value) => !value || (value.size && value.size <= 400 * 1024)
        );
    }
    return schema.notRequired();
  }),

  SponsorPlacementRequests: Yup.array()
    .of(
      Yup.object().shape({
        // always a boolean flag
        isActive: Yup.boolean().required(),
        sponsorPlacementType: Yup.string().required(
          "8:Placement type is required"
        ),

        // allow null when isActive is false
        startDate: Yup.string()
          .nullable()
          .when("isActive", (isActive, schema) =>
            isActive
              ? schema
                  .required("5:Start date is required")
                  .matches(
                    customDateRegex,
                    "Start date must be in the correct format"
                  )
              : schema
          ),

        endDate: Yup.string()
          .nullable()
          .when("isActive", (isActive, schema) =>
            isActive
              ? schema
                  .required("6:End date is required")
                  .matches(
                    customDateRegex,
                    "End date must be in the correct format"
                  )
                  .test(
                    "min-duration",
                    "9:Schedule must be at least 1 day",
                    function (value) {
                      const { startDate } = this.parent;
                      if (!startDate || !value) return false;
                      const start = new Date(startDate.substring(0, 19));
                      const end = new Date(value.substring(0, 19));
                      return (
                        (end - start) / (1000 * 60 * 60 * 24)
                      ) >= 1;
                    }
                  )
                  .test(
                    "end-after-start",
                    "7:End date cannot be before start date",
                    function (value) {
                      const { startDate } = this.parent;
                      if (!startDate || !value) return false;
                      return (
                        new Date(value.substring(0, 19)) >=
                        new Date(startDate.substring(0, 19))
                      );
                    }
                  )
              : schema
          ),

        weeklyEmailSlot: Yup.string(),
        Slot: Yup.string(),
        duration: Yup.number(),

        // these always required
        dateCreated: Yup.string().required(),
        dateUpdated: Yup.string().required(),
      })
    )
    .notRequired()
    .test(
      "weekly-email-slot-required",
      "12:Logo Slot must be selected if Weekly Email or Weekly System Report is enabled",
      function (placementRequests) {
        if (!placementRequests || placementRequests.length === 0) return true;
        return placementRequests.every((p) => {
          if (
            p.isActive &&
            (p.sponsorPlacementType === "WeeklyEmail" ||
              p.sponsorPlacementType === "WeeklySystemReport")
          ) {
            return p.weeklyEmailSlot !== undefined && p.weeklyEmailSlot !== "";
          }
          return true;
        });
      }
    ),
});
